import {
	AlertCircle,
	ArrowLeftRight,
	Award,
	BarChart3,
	BellRing,
	BookOpen,
	BookOpenCheck,
	Bot,
	Boxes,
	Building2,
	Calculator,
	Calendar,
	CalendarClock,
	CheckSquare,
	ClipboardPlus,
	Database,
	Eye,
	Factory,
	FileDown,
	FileText,
	FlaskConical,
	Gauge,
	GitCompare,
	HandCoins,
	Handshake,
	HardDrive,
	Headphones,
	Inbox,
	Key,
	Layers,
	Layers3,
	LayoutDashboard,
	Link2,
	ListChecks,
	ListOrdered,
	type LucideIcon,
	Mail,
	MessageSquare,
	Monitor,
	Package,
	PackageX,
	Percent,
	PieChart,
	Pill,
	Printer,
	Receipt,
	RefreshCw,
	Rocket,
	Scale,
	ScrollText,
	Search,
	Send,
	Settings,
	Shield,
	ShieldCheck,
	ShieldOff,
	ShoppingCart,
	Sliders,
	SlidersHorizontal,
	Sparkles,
	Star,
	Store,
	Table,
	Tag,
	Tags,
	Target,
	TrendingDown,
	TrendingUp,
	TriangleAlert,
	Trophy,
	Unlink,
	Upload,
	UserCheck,
	UserRoundCog,
	Users,
	UsersRound,
	Warehouse,
} from "lucide-react";

export interface SidebarItem {
	title: string;
	href: string;
	icon?: LucideIcon;
	id?: string;
}

export interface SidebarGroup {
	title: string;
	icon: LucideIcon;
	items: SidebarItem[];
}

export interface SidebarModule {
	id: string;
	title: string;
	icon: LucideIcon;
	isFavorites?: boolean;
	items?: SidebarItem[];
	groups?: SidebarGroup[];
}

export const sidebarModules: SidebarModule[] = [
	{
		id: "ulubione",
		title: "Ulubione",
		icon: Star,
		isFavorites: true,
	},
	{
		id: "pulpit",
		title: "Pulpit",
		icon: LayoutDashboard,
		items: [{ title: "Dashboard", href: "/dashboard", icon: LayoutDashboard }],
	},
	{
		id: "helpdesk",
		title: "Helpdesk",
		icon: Headphones,
		// Nad „Zdalny dostęp” (Urządzenia). Tylko super_admin (dział IT), reguły w migracji
		// helpdesku v527. Czat apteki (/helpdesk/czat) jest pod elementem „Obsługa”.
		items: [
			{
				title: "Obsługa",
				href: "/helpdesk",
				icon: Inbox,
				id: "sidebar.helpdesk.obsluga",
			},
			{
				title: "Wyszukiwarka",
				href: "/helpdesk/szukaj",
				icon: Search,
				id: "sidebar.helpdesk.szukaj",
			},
			{
				title: "Zarządzanie",
				href: "/helpdesk/zarzadzanie",
				icon: ListChecks,
				id: "sidebar.helpdesk.zarzadzanie",
			},
			{
				title: "Konfiguracja",
				href: "/helpdesk/konfiguracja",
				icon: Settings,
				id: "sidebar.helpdesk.konfiguracja",
			},
		],
	},
	{
		// Osobna sekcja top-level (pod Helpdeskiem) — z modulu korzystaja tez ksiegowe,
		// nie tylko IT (RFC §9 address book). Widocznosc: grant visibility_rules na
		// module id sidebar.zdalny-dostep + item sidebar.konfiguracja.urzadzenia.
		id: "zdalny-dostep",
		title: "Zdalny dostęp",
		icon: Monitor,
		items: [
			{
				title: "Urządzenia",
				href: "/konfiguracja/urzadzenia",
				icon: Monitor,
				id: "sidebar.konfiguracja.urzadzenia",
			},
			{
				title: "Drukarki",
				href: "/konfiguracja/drukarki",
				icon: Printer,
				id: "sidebar.konfiguracja.drukarki",
			},
			{
				// D109: bez grantów — widzi tylko super_admin (backend wymaga jego sesji).
				title: "Pracownicy",
				href: "/konfiguracja/pracownicy",
				icon: UserRoundCog,
				id: "sidebar.konfiguracja.pracownicy",
			},
			{
				title: "Aktualizacje",
				href: "/konfiguracja/aktualizacje",
				icon: RefreshCw,
				id: "sidebar.zdalny-dostep.aktualizacje",
			},
			{
				title: "Harmonogramy",
				href: "/konfiguracja/harmonogramy-powiadomien",
				icon: BellRing,
				id: "sidebar.zdalny-dostep.harmonogramy",
			},
			{
				title: "Reguły zdarzeń",
				href: "/konfiguracja/reguly-zdarzen",
				icon: TriangleAlert,
				id: "sidebar.zdalny-dostep.reguly-zdarzen",
			},
		],
	},
	{
		// Podzial na grupy tematyczne (nie po odbiorcy — raport ma zwykle wiecej niz
		// jednego, a odbiorce zalatwiaja granty). Grupy nie maja wlasnego element_id:
		// pusta grupa znika sama (MenuGroups w details-panel.tsx), wiec uzytkownik
		// z dwoma grantami nie oglada pieciu pustych naglowkow.
		id: "raporty",
		title: "Raporty",
		icon: BarChart3,
		items: [
			{
				title: "Dashboard analityczny",
				href: "/raporty/dashboard-analityczny",
				icon: LayoutDashboard,
				id: "sidebar.raporty.dashboard-analityczny",
			},
		],
		groups: [
			{
				title: "Sprzedaż i marża",
				icon: BarChart3,
				items: [
					{
						title: "Sprzedaż dzienna",
						href: "/raporty/sprzedaz-dzienna",
						icon: BarChart3,
						id: "sidebar.raporty.sprzedaz-dzienna",
					},
					{
						title: "Dynamika sprzedaży",
						href: "/raporty/dynamika-sprzedazy",
						icon: BarChart3,
						id: "sidebar.raporty.dynamika-sprzedazy",
					},
					{
						title: "Sprzedaż zrealizowana",
						href: "/raporty/sprzedaz-zrealizowana",
						icon: BarChart3,
						id: "sidebar.raporty.sprzedaz-zrealizowana",
					},
					{
						title: "Ujemne marże",
						href: "/raporty/ujemne-marze",
						icon: BarChart3,
						id: "sidebar.raporty.ujemne-marze",
					},
					{
						title: "Rozkład marż",
						href: "/raporty/rozklad-marz",
						icon: BarChart3,
						id: "sidebar.raporty.rozklad-marz",
					},
				],
			},
			{
				title: "Zakupy i ceny",
				icon: ShoppingCart,
				items: [
					{
						title: "Analiza - Nowe zamówienie",
						href: "/raporty/analiza-zakupow-nowe-zam",
						icon: BarChart3,
						id: "sidebar.raporty.analiza-zakupow-nowe-zam",
					},
					{
						title: "Analiza - Zakupy indeksów",
						href: "/raporty/analiza-zakupy-indeksow",
						icon: BarChart3,
						id: "sidebar.raporty.analiza-zakupy-indeksow",
					},
					{
						title: "Odchylenia cen FV",
						href: "/raporty/odchylenia-cen-fv",
						icon: BarChart3,
						id: "sidebar.raporty.odchylenia-cen-fv",
					},
				],
			},
			{
				title: "Magazyn i zwroty",
				icon: Warehouse,
				items: [
					{
						title: "Zwroty dzienne",
						href: "/raporty/zwroty-dzienne",
						icon: PackageX,
						id: "sidebar.raporty.zwroty-dzienne",
					},
					{
						title: "Zwroty kwartalne",
						href: "/raporty/zwroty-kwartalne",
						icon: PackageX,
						id: "sidebar.raporty.zwroty-kwartalne",
					},
					{
						title: "Daty ważności",
						href: "/raporty/daty-waznosci",
						icon: CalendarClock,
						id: "sidebar.raporty.daty-waznosci",
					},
					{
						title: "Wyprzedaż magazynu",
						href: "/raporty/wyprzedaz-magazynu",
						icon: Warehouse,
						id: "sidebar.raporty.wyprzedaz-magazynu",
					},
				],
			},
			{
				title: "Produkty i kategorie",
				icon: Package,
				items: [
					{
						title: "Raport produktowy",
						href: "/raporty/raport-produktowy",
						icon: Package,
						id: "sidebar.raporty.raport-produktowy",
					},
					{ title: "ECOM", href: "/raporty/ecom", icon: Package, id: "sidebar.raporty.ecom" },
					{
						title: "Analiza kategorii (kwartalna)",
						href: "/raporty/kategoria-kwartalna",
						icon: Layers,
						id: "sidebar.raporty.kategoria-kwartalna",
					},
				],
			},
			{
				// Jedna rodzina raportow napedzana ta sama lista blozow (identyczny
				// search schema: listId/mode/apteka). Parametry listy celowo NIE sa
				// pozycja menu — wchodzi sie w nie przyciskiem Konfiguracja na
				// raporcie, a element `page.raporty.sprz-wybranych-blozow.konfiguracja`
				// rejestruje sam raport (sprz-wybranych-blozow-page.tsx), wiec edytor
				// widocznosci dalej moze nadac to uprawnienie.
				title: "Analizy premiowe",
				icon: HandCoins,
				items: [
					{
						title: "Sprz wybranych blozów",
						href: "/raporty/sprz-wybranych-blozow",
						icon: Table,
						id: "sidebar.raporty.sprz-wybranych-blozow",
					},
					{
						title: "Sprzedaż opiekun",
						href: "/raporty/sprz-opiekun",
						icon: UserCheck,
						id: "sidebar.raporty.sprz-opiekun",
					},
					{
						title: "Sprzedaż wyniki",
						href: "/raporty/sprz-wynik",
						icon: PieChart,
						id: "sidebar.raporty.sprz-wynik",
					},
				],
			},
			{
				// Przenoszony z FM1 formatka po formatce — na razie dane wejsciowe
				// ("w_*"), obliczenia premii dojda pozniej. Tylko analyst + super_admin.
				title: "System premiowy",
				icon: Trophy,
				items: [
					{
						title: "Lider i Natubay",
						href: "/raporty/system-premiowy/lider",
						icon: Award,
						id: "sidebar.raporty.sys-premiowy-lider",
					},
					{
						title: "Struktura",
						href: "/raporty/system-premiowy/struktura",
						icon: Layers3,
						id: "sidebar.raporty.sys-premiowy-struktura",
					},
					{
						title: "Rentowność aptek",
						href: "/raporty/system-premiowy/rentownosc",
						icon: Percent,
						id: "sidebar.raporty.sys-premiowy-rentownosc",
					},
					{
						title: "Program partnerski",
						href: "/raporty/system-premiowy/program-partnerski",
						icon: Handshake,
						id: "sidebar.raporty.sys-premiowy-program-partnerski",
					},
					{
						// Wynik obliczen (FM1 "Lider szczegolowo"); PESEL pelny tylko z
						// elementem page.sprz-kasjer-data.pesel.
						title: "Lider szczegółowo",
						href: "/raporty/system-premiowy/lider-szczegolowo",
						icon: ListChecks,
						id: "sidebar.raporty.sys-premiowy-lider-szczegolowo",
					},
				],
			},
			{
				// Strony jeszcze niezbudowane (UNIMPLEMENTED_HREFS) — trzymane osobno,
				// zeby nie zasmiecaly grup tematycznych. Edytor widocznosci i tak
				// blokuje nadanie im grantu.
				title: "BI (w budowie)",
				icon: FlaskConical,
				items: [
					{
						title: "Sprzedaz",
						href: "/sprzedaz",
						icon: ShoppingCart,
						id: "sidebar.raporty.sprzedaz",
					},
					{ title: "Magazyn", href: "/bi/magazyn", icon: Warehouse, id: "sidebar.raporty.magazyn" },
					{
						title: "Pacjenci",
						href: "/bi/klienci",
						icon: UserCheck,
						id: "sidebar.raporty.pacjenci",
					},
					{ title: "Cele", href: "/bi/cele", icon: Target, id: "sidebar.raporty.cele" },
				],
			},
		],
	},
	{
		// Raporty z danymi wrazliwymi (PESEL kasjera/pacjenta, NIP, etc.).
		// Wymagaja dedykowanej widocznosci per-rola — domyslnie tylko super_admin.
		// Convention element_id: `sidebar.raporty-pesel.<itemSlug>`.
		id: "raporty-pesel",
		title: "Raporty z peselem",
		icon: Shield,
		items: [
			{
				title: "Sprzedaż kasjer-data",
				href: "/raporty/sprz_kasjer_data",
				icon: BarChart3,
				id: "sidebar.raporty-pesel.sprz-kasjer-data",
			},
		],
	},
	{
		id: "dokumenty",
		title: "Dokumenty",
		icon: FileText,
		items: [
			{
				title: "Faktury KSeF",
				href: "/dokumenty/ksef",
				icon: Receipt,
				id: "sidebar.dokumenty.ksef",
			},
			{
				title: "Kalendarz platnosci",
				href: "/dokumenty/kalendarz-platnosci",
				icon: Calendar,
				id: "sidebar.dokumenty.kalendarz-platnosci",
			},
			{
				title: "Hurtownie",
				href: "/dokumenty/hurtownicy",
				icon: Handshake,
				id: "sidebar.dokumenty.hurtownicy",
			},
		],
	},
	{
		id: "zamowienia",
		title: "Zamowienia",
		icon: ShoppingCart,
		items: [
			{
				title: "Nowe zamowienie",
				href: "/zamowienia/nowe",
				icon: ClipboardPlus,
				id: "sidebar.zamowienia.nowe",
			},
			{
				title: "Lista zamowien",
				href: "/zamowienia",
				icon: ListOrdered,
				id: "sidebar.zamowienia.lista",
			},
		],
	},
	{
		id: "analityka",
		title: "Analityka BI",
		icon: Bot,
		items: [
			{
				title: "Asystent Farmaceuty",
				href: "/asystent",
				icon: Bot,
				id: "sidebar.analityka.asystent",
			},
			{
				title: "AI — koszty",
				href: "/asystent-koszty",
				icon: Receipt,
				id: "sidebar.analityka.asystent-koszty",
			},
			{
				title: "Jakość Asystenta",
				href: "/asystent-jakosc",
				icon: Shield,
				id: "sidebar.analityka.asystent-jakosc",
			},
			{
				title: "Asystent — statystyki",
				href: "/asystent-statystyki-aptek",
				icon: BarChart3,
				id: "sidebar.analityka.asystent-statystyki-aptek",
			},
			{ title: "BI Query", href: "/bi/query", icon: Database, id: "sidebar.analityka.query" },
		],
	},
	{
		id: "sms",
		title: "SMS",
		icon: MessageSquare,
		items: [
			{ title: "Kampanie", href: "/sms/kampanie", icon: Send, id: "sidebar.sms.kampanie" },
			{ title: "Kontakty", href: "/sms/kontakty", icon: Users, id: "sidebar.sms.kontakty" },
			{
				title: "Szablony",
				href: "/sms/szablony",
				icon: FileText,
				id: "sidebar.sms.szablony",
			},
			{ title: "Zuzycie", href: "/sms/zuzycie", icon: Receipt, id: "sidebar.sms.zuzycie" },
		],
	},
	{
		id: "prawo",
		title: "Prawo",
		icon: Scale,
		items: [
			{ title: "Akty prawne", href: "/prawo/akty", icon: ScrollText, id: "sidebar.prawo.akty" },
			{
				title: "Projekty ustaw",
				href: "/prawo/projekty",
				icon: FileText,
				id: "sidebar.prawo.projekty",
			},
			{
				title: "Zadania dla apteki",
				href: "/prawo/zadania",
				icon: CheckSquare,
				id: "sidebar.prawo.zadania",
			},
		],
	},
	{
		id: "marka-wlasna",
		title: "Marka Wlasna",
		icon: Tag,
		items: [
			{
				title: "Dashboard MW",
				href: "/marka-wlasna",
				icon: PieChart,
				id: "sidebar.marka-wlasna.dashboard",
			},
			{
				title: "Sprzedaz wg Produktow",
				href: "/marka-wlasna/produkty",
				icon: Package,
				id: "sidebar.marka-wlasna.produkty",
			},
			{
				title: "Sprzedaz wg Aptek",
				href: "/marka-wlasna/apteki",
				icon: Store,
				id: "sidebar.marka-wlasna.apteki",
			},
			{
				title: "Sprzedaz wg Spolek",
				href: "/marka-wlasna/spolki",
				icon: Building2,
				id: "sidebar.marka-wlasna.spolki",
			},
			{
				title: "Sprzedaz wg Pracownikow",
				href: "/marka-wlasna/pracownicy",
				icon: UsersRound,
				id: "sidebar.marka-wlasna.pracownicy",
			},
			{
				title: "Zakupy wg Aptek",
				href: "/marka-wlasna/zakupy-apteki",
				icon: ShoppingCart,
				id: "sidebar.marka-wlasna.zakupy-apteki",
			},
			{
				title: "Analiza kategorii",
				href: "/marka-wlasna/kategorie",
				icon: Layers,
				id: "sidebar.marka-wlasna.kategorie",
			},
			{
				title: "Wsparcie sprzedazy",
				href: "/marka-wlasna/wsparcie",
				icon: Target,
				id: "sidebar.marka-wlasna.wsparcie",
			},
			{
				title: "Asystent AI MW",
				href: "/marka-wlasna/ai",
				icon: Bot,
				id: "sidebar.marka-wlasna.ai",
			},
		],
	},
	{
		id: "strateg-cenowy",
		title: "Strateg Cenowy",
		icon: TrendingUp,
		groups: [
			{
				title: "Cennik celowany (decyle IQVIA)",
				icon: BarChart3,
				items: [
					{
						title: "Wyniki analizy",
						href: "/strateg-cenowy/wyniki",
						icon: BarChart3,
						id: "sidebar.strateg-cenowy.wyniki",
					},
					{
						title: "Strategie cenowe",
						href: "/strateg-cenowy/strategie",
						icon: Settings,
						id: "sidebar.strateg-cenowy.strategie",
					},
					{
						title: "Modyfikatory",
						href: "/strateg-cenowy/modyfikatory",
						icon: Sliders,
						id: "sidebar.strateg-cenowy.modyfikatory",
					},
					{
						title: "Wykluczenia",
						href: "/strateg-cenowy/wykluczenia",
						icon: ShieldOff,
						id: "sidebar.strateg-cenowy.wykluczenia",
					},
					{
						title: "Cenniki wlasne",
						href: "/strateg-cenowy/cenniki-wlasne",
						icon: Tags,
						id: "sidebar.strateg-cenowy.cenniki-wlasne",
					},
					{
						title: "Cenniki centralne",
						href: "/strateg-cenowy/cenniki-centralne",
						icon: Tags,
						id: "sidebar.strateg-cenowy.cenniki-centralne",
					},
				],
			},
			{
				title: "Algorytm TOP (T1/T2/T3)",
				icon: Sparkles,
				items: [
					{
						title: "Wyniki TOP",
						href: "/strateg-cenowy/wyniki-top",
						icon: Sparkles,
						id: "sidebar.strateg-cenowy.wyniki-top",
					},
					{
						title: "Konfiguracja TOP",
						href: "/strateg-cenowy/konfiguracja-top",
						icon: SlidersHorizontal,
						id: "sidebar.strateg-cenowy.konfiguracja-top",
					},
				],
			},
			{
				title: "Cenniki franczyzowe",
				icon: Tags,
				items: [
					{
						title: "Lider Franczyza",
						href: "/strateg-cenowy/lider-franczyza",
						icon: Tags,
						id: "sidebar.strateg-cenowy.lider-franczyza",
					},
				],
			},
			{
				title: "Kalkulator marży",
				icon: Calculator,
				items: [
					{
						title: "Wyniki kalkulatora",
						href: "/strateg-cenowy/kalkulator-marzy",
						icon: Calculator,
						id: "sidebar.strateg-cenowy.kalkulator-marzy",
					},
				],
			},
		],
	},
	{
		id: "kartoteka",
		title: "Kartoteka",
		icon: BookOpen,
		items: [
			{
				title: "Produkty centralne",
				href: "/kartoteka/towary",
				icon: Package,
				id: "sidebar.kartoteka.towary",
			},
			{
				title: "Producenci",
				href: "/kartoteka/producenci",
				icon: Factory,
				id: "sidebar.kartoteka.producenci",
			},
			{
				title: "Kontrahenci centrali",
				href: "/kartoteka/kontrahenci",
				icon: Users,
				id: "sidebar.kartoteka.kontrahenci",
			},
			{
				title: "Historia cen (hurt)",
				href: "/kartoteka/cenniki-historia",
				icon: TrendingUp,
				id: "sidebar.kartoteka.cenniki-historia",
			},
			{
				title: "Podgląd cennika (hurt)",
				href: "/kartoteka/cenniki-podglad",
				icon: Table,
				id: "sidebar.kartoteka.cenniki-podglad",
			},
			{
				title: "Najtańszy dostawca",
				href: "/kartoteka/cennik-najtaniej",
				icon: TrendingDown,
				id: "sidebar.kartoteka.cennik-najtaniej",
			},
			{
				title: "Zgodność FM2↔FM1",
				href: "/kartoteka/cennik-zgodnosc",
				icon: GitCompare,
				id: "sidebar.kartoteka.cennik-zgodnosc",
			},
			{
				title: "Stan magazynu",
				href: "/kartoteka/stan-magazynu",
				icon: Warehouse,
				id: "sidebar.kartoteka.stan-magazynu",
			},
			{
				title: "Kategoryzacja",
				href: "/kartoteka/kategoryzacja",
				icon: Tags,
				id: "sidebar.kartoteka.kategoryzacja",
			},
			{
				title: "Mapowanie APC–BLOZ",
				href: "/kartoteka/mapowanie-apc",
				icon: Link2,
				id: "sidebar.kartoteka.mapowanie-apc",
			},
			{
				title: "Grupy produktów",
				href: "/kartoteka/grupy-produktow",
				icon: Layers,
				id: "sidebar.kartoteka.grupy-produktow",
			},
		],
	},
	{
		id: "receptura",
		title: "Receptura",
		icon: FlaskConical,
		items: [
			{
				title: "Protokoły",
				href: "/receptura/protokoly",
				icon: ClipboardPlus,
				id: "sidebar.receptura.protokoly",
			},
			{
				title: "Szablony receptur",
				href: "/receptura/szablony",
				icon: BookOpenCheck,
				id: "sidebar.receptura.szablony",
			},
			{
				title: "Surowce",
				href: "/receptura/surowce",
				icon: Pill,
				id: "sidebar.receptura.surowce",
			},
		],
	},
	{
		id: "kontrakty",
		title: "Kontrakty",
		icon: Handshake,
		groups: [
			{
				title: "Z producentem",
				icon: Factory,
				items: [
					{
						title: "Nowy kontrakt",
						href: "/kontrakty/nowy",
						icon: ClipboardPlus,
						id: "sidebar.kontrakty.kontrakty",
					},
					{
						title: "Definicje",
						href: "/kontrakty",
						icon: FileText,
						id: "sidebar.kontrakty.definicje",
					},
					{
						title: "Nieaktywne apteki",
						href: "/kontrakty/nieaktywne-apteki",
						icon: AlertCircle,
						id: "sidebar.kontrakty.nieaktywne-apteki",
					},
					{
						title: "Rozliczenie",
						href: "/kontrakty/rozliczenia",
						icon: BarChart3,
						id: "sidebar.kontrakty.szablony",
					},
					{
						// Widok dla kierownikow sieci (franczyza / wlasne) — wykonanie
						// widocznych aptek per kontrakt, bez celow kontraktu.
						title: "Wykonanie",
						href: "/kontrakty/wykonanie",
						icon: Gauge,
						id: "sidebar.kontrakty.wykonanie",
					},
					{
						title: "Porównanie z plikiem",
						href: "/kontrakty/porownanie",
						icon: ArrowLeftRight,
						id: "sidebar.kontrakty.porownanie",
					},
					{
						title: "Porównanie z producentem",
						href: "/kontrakty/porownanie-z-producentem",
						icon: ArrowLeftRight,
						id: "sidebar.kontrakty.porownanie-z-producentem",
					},
					{
						title: "Prognoza wsteczna",
						href: "/kontrakty/rozliczenia/prognoza-wsteczna",
						icon: TrendingUp,
						id: "sidebar.kontrakty.prognoza-wsteczna",
					},
					{
						title: "Proporcje kanałów",
						href: "/kontrakty/rozliczenia/proporcje-kanalow",
						icon: Scale,
						id: "sidebar.kontrakty.proporcje-kanalow",
					},
					{
						title: "Aktywność aptek",
						href: "/kontrakty/rozliczenia/aktywnosc-aptek",
						icon: Store,
						id: "sidebar.kontrakty.aktywnosc-aptek",
					},
					{
						title: "Udział",
						href: "/kontrakty/udzial",
						icon: PieChart,
						id: "sidebar.kontrakty.udzial",
					},
					{
						title: "Cenniki ex-factory",
						href: "/kontrakty/cenniki-exfactory",
						icon: Tag,
						id: "sidebar.kontrakty.nowy",
					},
					{
						title: "MSL - dostępność",
						href: "/kontrakty/msl-dostepnosc",
						icon: Boxes,
						id: "sidebar.kontrakty.msl-dostepnosc",
					},
					{
						title: "Monitoring",
						href: "/monitoring",
						icon: TrendingUp,
						id: "sidebar.kontrakty.monitoring",
					},
					{
						title: "Zadania",
						href: "/zadania",
						icon: CheckSquare,
						id: "sidebar.kontrakty.zadania",
					},
				],
			},
			{
				title: "Franczyzowe",
				icon: Store,
				items: [
					{
						title: "Producenci DZZF",
						href: "/kontrakty/producenci-dzzf",
						icon: Factory,
						id: "sidebar.kontrakty.producenci-dzzf",
					},
					{
						title: "Apteki producentów",
						href: "/kontrakty/apteki-producentow",
						icon: Store,
						id: "sidebar.kontrakty.apteki-producentow",
					},
					{
						title: "Dopłaty GAP",
						href: "/kontrakty/doplaty-gap",
						icon: HandCoins,
						id: "sidebar.kontrakty.doplaty-gap",
					},
					{
						title: "Apteki GAP",
						href: "/kontrakty/apteki-gap",
						icon: Store,
						id: "sidebar.kontrakty.apteki-gap",
					},
					{
						title: "Lider zakupy",
						href: "/kontrakty/lider-zakupy",
						icon: TrendingUp,
						id: "sidebar.kontrakty.lider-zakupy",
					},
					{
						title: "Raport lider",
						href: "/kontrakty/raporty/lider",
						icon: BarChart3,
						id: "sidebar.kontrakty.raporty-lider",
					},
					{
						title: "Raport kontrakt",
						href: "/kontrakty/raporty/kontrakt",
						icon: BarChart3,
						id: "sidebar.kontrakty.raporty-kontrakt",
					},
					{
						title: "Raport producent",
						href: "/kontrakty/raporty/producent",
						icon: BarChart3,
						id: "sidebar.kontrakty.raporty-producent",
					},
					{
						title: "Raport podsumowanie",
						href: "/kontrakty/raporty/podsumowanie",
						icon: BarChart3,
						id: "sidebar.kontrakty.raporty-podsumowanie",
					},
				],
			},
		],
	},
	{
		id: "rda",
		title: "RDA",
		icon: HandCoins,
		items: [
			{
				title: "Analiza korzyści",
				href: "/rda/analiza-korzysci",
				icon: BarChart3,
				id: "sidebar.rda.analiza-korzysci",
			},
			{
				title: "Lista ofert FM1",
				href: "/rda/lista-ofert-fm1",
				icon: ListChecks,
				id: "sidebar.rda.lista-ofert-fm1",
			},
		],
	},
	{
		// Apteneo — sieć rozważana do przejęcia. Dane wchodzą plikiem (BLOZ +
		// ilość zakupu na kwartał), nie z Robota; moduł służy wycenie zakupu sieci.
		id: "apteneo",
		title: "Apteneo",
		icon: Building2,
		items: [
			{
				title: "Zaczytaj dane",
				href: "/apteneo/zaczytaj-dane",
				icon: Upload,
				id: "sidebar.apteneo.zaczytaj-dane",
			},
			{
				title: "Zakupy",
				href: "/apteneo/zakupy",
				icon: ShoppingCart,
				id: "sidebar.apteneo.zakupy",
			},
			{
				title: "Porównanie z Prima",
				href: "/apteneo/porownanie",
				icon: Scale,
				id: "sidebar.apteneo.porownanie",
			},
			{
				title: "Rozliczenia kontraktowe",
				href: "/apteneo/rozliczenia",
				icon: HandCoins,
				id: "sidebar.apteneo.rozliczenia",
			},
		],
	},
	{
		id: "kontrola-danych",
		title: "Kontrola danych",
		icon: Shield,
		items: [
			{
				title: "Weryfikacja sprzedazy",
				href: "/raporty/weryfikacja-sprzedazy",
				icon: BarChart3,
				id: "sidebar.raporty.weryfikacja-sprzedazy",
			},
			{
				title: "Weryfikacja sprzedaży - zmiany",
				href: "/raporty/weryfikacja-sprzedazy/zmiany",
				icon: BarChart3,
				id: "sidebar.raporty.weryfikacja-sprzedazy-zmiany",
			},
			{
				title: "Faktura do paragonu",
				href: "/raporty/weryfikacja-sprzedazy/faktura-do-paragonu",
				icon: BarChart3,
				id: "sidebar.raporty.faktura-do-paragonu",
			},
			{
				title: "Zmiany BLOZ kart towarów",
				href: "/raporty/zmiany-blozu",
				icon: GitCompare,
				id: "sidebar.raporty.zmiany-blozu",
			},
			{
				title: "Weryfikacja towr",
				href: "/raporty/weryfikacja-towr",
				icon: BarChart3,
				id: "sidebar.raporty.weryfikacja-towr",
			},
			{
				title: "Raport jakości danych / wyjątki",
				href: "/raporty/jakosc-danych-wyjatki",
				icon: BarChart3,
				id: "sidebar.raporty.analiza-zakupow-nowe-zam",
			},
			{
				title: "Luki powiązań",
				href: "/raporty/luki-powiazan",
				icon: Unlink,
				id: "sidebar.raporty.luki-powiazan",
			},
		],
	},
	{
		// Porównanie APTEKA (ERP) · Source · Target per apteka i dzień (doc/robot/
		// AGENT_SYNC_F1.md). Osobny moduł bez rodzica w modelu widoczności: element
		// modułu i pozycji to ten sam `sidebar.synchronizacja-apteki` (grant backendu
		// /api/agent-sync), więc jeden grant daje naraz menu i dostęp do trasy.
		id: "synchronizacja-apteki",
		title: "Synchronizacja",
		icon: ArrowLeftRight,
		items: [
			{
				title: "Synchronizacja z apteki",
				href: "/synchronizacja/apteki",
				icon: ArrowLeftRight,
				id: "sidebar.synchronizacja-apteki",
			},
			{
				// Skrót do SQL Konsoli (F4, start na Target). Element bez grantów —
				// widzi go tylko super_admin, jedyna rola z trybem apteki konsoli.
				title: "Konsola SQL",
				href: "/synchronizacja/konsola-sql",
				icon: Database,
				id: "sidebar.synchronizacja-apteki.konsola-sql",
			},
			{
				// Zatwierdzenia zapisów konsoli ERP ze wszystkich aptek (F4) — bez szukania apteki.
				// Element bez grantów, jak Konsola SQL: tylko super_admin.
				title: "Zatwierdzenia SQL",
				href: "/synchronizacja/zatwierdzenia-sql",
				icon: ShieldCheck,
				id: "sidebar.synchronizacja-apteki.zatwierdzenia-sql",
			},
		],
	},
	{
		id: "system",
		title: "System",
		icon: Settings,
		groups: [
			{
				title: "Slowniki",
				icon: BookOpen,
				items: [
					{ title: "Leki", href: "/konfiguracja/leki", icon: Pill, id: "sidebar.system.leki" },
					{
						title: "Apteki",
						href: "/konfiguracja/apteki",
						icon: Building2,
						id: "sidebar.system.apteki",
					},
					{
						title: "Spolki",
						href: "/konfiguracja/spolki",
						icon: Building2,
						id: "sidebar.system.spolki",
					},
					{
						title: "Hurtownie",
						href: "/konfiguracja/hurtownie",
						icon: Package,
						id: "sidebar.system.hurtownie",
					},
					{
						title: "Producenci",
						href: "/konfiguracja/producenci",
						icon: Pill,
						id: "sidebar.system.producenci",
					},
				],
			},
			{
				title: "Administracja",
				icon: Shield,
				items: [
					{
						title: "Uzytkownicy",
						href: "/konfiguracja/uzytkownicy",
						icon: Users,
						id: "sidebar.system.uzytkownicy",
					},
					{
						title: "Podgląd użytkownika",
						href: "/konfiguracja/podglad-uzytkownika",
						icon: Eye,
						id: "sidebar.system.podglad-uzytkownika",
					},
					{
						title: "Statystyki użycia",
						href: "/konfiguracja/statystyki-uzycia",
						icon: BarChart3,
						id: "sidebar.system.statystyki-uzycia",
					},
					{
						title: "Audit Log",
						href: "/konfiguracja/audit-log",
						icon: ScrollText,
						id: "sidebar.system.audit-log",
					},
					{
						title: "Email Log",
						href: "/konfiguracja/email-log",
						icon: Mail,
						id: "sidebar.system.email-log",
					},
					{
						title: "SMS — konfiguracja",
						href: "/konfiguracja/sms",
						icon: MessageSquare,
						id: "sidebar.system.sms",
					},
					{
						title: "Harmonogramy raportów",
						href: "/konfiguracja/harmonogramy-raportow",
						icon: Mail,
						id: "sidebar.system.harmonogramy-raportow",
					},
					{
						title: "SQL Konsola",
						href: "/konfiguracja/sql-konsola",
						icon: Database,
						id: "sidebar.system.sql-konsola",
					},
					{
						title: "System",
						href: "/konfiguracja/system",
						icon: Rocket,
						id: "sidebar.system.system",
					},
					{
						title: "Dyski",
						href: "/konfiguracja/dyski",
						icon: HardDrive,
						id: "sidebar.system.dyski",
					},
					{
						title: "Grupy Aptek",
						href: "/konfiguracja/grupy-aptek",
						icon: Building2,
						id: "sidebar.system.grupy-aptek",
					},
					{
						title: "Role i Uprawnienia",
						href: "/konfiguracja/grupy-organizacyjne",
						icon: UsersRound,
						id: "sidebar.system.grupy-organizacyjne",
					},
					{
						title: "Grupy użytkowników",
						href: "/konfiguracja/grupy-uzytkownikow",
						icon: UserRoundCog,
						id: "sidebar.system.grupy-uzytkownikow",
					},
					{
						title: "Organizacje",
						href: "/konfiguracja/organizacje",
						icon: Building2,
						id: "sidebar.system.organizacje",
					},
					{
						title: "Integracje",
						href: "/konfiguracja/integracje",
						icon: Database,
						id: "sidebar.system.integracje",
					},
					{
						title: "Ustawienia",
						href: "/konfiguracja/ustawienia",
						icon: Settings,
						id: "sidebar.system.ustawienia",
					},
					{ title: "KSeF", href: "/konfiguracja/ksef", icon: FileText, id: "sidebar.system.ksef" },
					{
						title: "Certyfikaty KSeF",
						href: "/konfiguracja/ksef-certyfikaty",
						icon: Shield,
						id: "sidebar.system.ksef-certyfikaty",
					},
					{
						title: "OSOZ-EDI (admin)",
						href: "/konfiguracja/ksef-osoz-edi",
						icon: FileText,
						id: "sidebar.konfiguracja.ksef_osoz_edi",
					},
					{
						title: "Tokeny API",
						href: "/konfiguracja/tokeny-api",
						icon: Key,
						id: "sidebar.system.tokeny-api",
					},
					{
						title: "Konfiguracja AI",
						href: "/konfiguracja/ai",
						icon: Bot,
						id: "sidebar.system.ai-config",
					},
					{
						title: "Konfiguracja e-mail",
						href: "/konfiguracja/email",
						icon: Mail,
						id: "sidebar.system.email-config",
					},
					{
						title: "IQVIA MOVEit",
						href: "/konfiguracja/iqvia",
						icon: FileDown,
						id: "sidebar.system.iqvia",
					},
				],
			},
			{
				title: "MCP (Podłącz AI)",
				icon: Sparkles,
				items: [
					{
						title: "Zarządzanie MCP",
						href: "/konfiguracja/mcp",
						icon: SlidersHorizontal,
						id: "sidebar.system.mcp",
					},
					{
						title: "Statystyki MCP",
						href: "/konfiguracja/mcp-statystyki",
						icon: BarChart3,
						id: "sidebar.system.mcp-statystyki",
					},
				],
			},
			{
				title: "Producenci",
				icon: Factory,
				items: [
					{
						title: "SFY — rozbieznosci",
						href: "/konfiguracja/sfy/przeglad",
						icon: Database,
						id: "sidebar.system.sfy-przeglad",
					},
					{
						title: "SFY (sync do klientow)",
						href: "/konfiguracja/sfy",
						icon: Database,
						id: "sidebar.system.sfy",
					},
					{
						title: "SFY (sql console)",
						href: "/konfiguracja/sql-sfy",
						icon: Database,
						id: "sidebar.system.sql-sfy",
					},
					{
						title: "Eksporty plikowe",
						href: "/konfiguracja/eksporty-plikowe",
						icon: Send,
						id: "sidebar.system.eksporty-plikowe",
					},
					{
						title: "Import MSHR (Polfarma)",
						href: "/konfiguracja/import-mshr",
						icon: Database,
						id: "sidebar.system.import-mshr",
					},
				],
			},
		],
	},
];

/**
 * Sidebar items whose target route does not exist yet — the page hasn't been
 * built. They stay in the config (so the structure is visible) but render with
 * a strike-through so nobody accidentally grants them in the visibility editor.
 *
 * SSoT keyed by `href`. When a page ships, delete its entry here. Verified
 * against `routes/_auth/` on 2026-06-18; a guard test (sidebar-config.test.ts)
 * pins this list to the actual route tree so it can't silently drift.
 */
export const UNIMPLEMENTED_HREFS: ReadonlySet<string> = new Set([
	"/sprzedaz",
	"/bi/magazyn",
	"/bi/klienci",
	"/bi/cele",
	"/bi/query",
	"/zamowienia",
	"/zamowienia/nowe",
	"/prawo/akty",
	"/prawo/projekty",
	"/prawo/zadania",
	"/marka-wlasna",
	"/marka-wlasna/produkty",
	"/marka-wlasna/apteki",
	"/marka-wlasna/spolki",
	"/marka-wlasna/pracownicy",
	"/marka-wlasna/zakupy-apteki",
	"/marka-wlasna/kategorie",
	"/marka-wlasna/wsparcie",
	"/marka-wlasna/ai",
	"/monitoring",
	"/zadania",
	"/konfiguracja/leki",
	"/konfiguracja/hurtownie",
	"/konfiguracja/producenci",
	"/konfiguracja/integracje",
	"/konfiguracja/ustawienia",
]);

/** True when the item's page exists. Sidebar strikes through the rest. */
export function isItemImplemented(href: string): boolean {
	return !UNIMPLEMENTED_HREFS.has(href);
}

// element_ids of sidebar items whose page isn't built — the visibility editor
// blocks granting these (no point enabling a route that 404s). Derived once.
let unimplementedElementIds: Set<string> | null = null;
export function getUnimplementedElementIds(): ReadonlySet<string> {
	if (unimplementedElementIds === null) {
		unimplementedElementIds = new Set();
		for (const mod of sidebarModules) {
			for (const item of getModuleItems(mod)) {
				if (UNIMPLEMENTED_HREFS.has(item.href)) {
					unimplementedElementIds.add(sidebarItemElementId(mod.id, item));
				}
			}
		}
	}
	return unimplementedElementIds;
}

export function getModuleItems(module: SidebarModule): SidebarItem[] {
	const items: SidebarItem[] = [];
	if (module.items) {
		items.push(...module.items);
	}
	if (module.groups) {
		module.groups.forEach((g) => {
			items.push(...g.items);
		});
	}
	return items;
}

/**
 * Mirrors the element_id that the sidebar UI registers for a given item via
 * `<Visible id="...">` (icon-bar.tsx, details-panel.tsx, hover-preview.tsx).
 * Must stay in lockstep with `getItemElementId` in routes/_auth.tsx — if the
 * sidebar ever renames how it computes element ids, change both.
 */
function sidebarItemElementId(moduleId: string, item: SidebarItem): string {
	if (item.id) return item.id;
	const lastSegment = item.href.split("/").filter(Boolean).pop() ?? item.href;
	return `sidebar.${moduleId}.${lastSegment}`;
}

/** Element id pozycji sidebara — ta sama regula w sidebarze, nawigacji dolnej i guardach. */
export const getSidebarItemElementId = sidebarItemElementId;

/**
 * Pozycja sidebara dla sciezki: dokladne dopasowanie, potem najdluzszy prefiks
 * (strony szczegolow). Moduly ulubionych pomijane. Mobilny pasek bierze z tego
 * tytul strony i nazwe modulu.
 */
export function findSidebarLocation(
	pathname: string,
): { module: SidebarModule; item: SidebarItem; exact: boolean } | null {
	let best: { module: SidebarModule; item: SidebarItem; exact: boolean } | null = null;
	for (const module of sidebarModules) {
		if (module.isFavorites) continue;
		for (const item of getModuleItems(module)) {
			if (item.href === pathname) return { module, item, exact: true };
			if (
				pathname.startsWith(`${item.href}/`) &&
				(best === null || item.href.length > best.item.href.length)
			) {
				best = { module, item, exact: false };
			}
		}
	}
	return best;
}

/**
 * Returns the static set of `sidebar.*` element ids that the sidebar UI is
 * guaranteed to register at render time — every module (`sidebar.{moduleId}`)
 * plus every item (from `item.id` or derived from the href). Used by the route
 * guard to replicate `isParentVisible` ancestor logic outside React, where the
 * runtime `registeredElements` Set isn't available.
 *
 * Derived from sidebar-config on module load — cheap, no runtime deps. If you
 * add a new sidebar module/item that should gate URL access, adding it to
 * `sidebarModules` automatically registers it here.
 */
export function getSidebarRegisteredElementIds(): Set<string> {
	const registered = new Set<string>();
	for (const mod of sidebarModules) {
		registered.add(`sidebar.${mod.id}`);
		for (const item of getModuleItems(mod)) {
			registered.add(sidebarItemElementId(mod.id, item));
		}
	}
	return registered;
}

// Lazy href → element_id map dla ulubionych/ostatnio-odwiedzanych: wpisy w
// localStorage przezywaja odebranie grantu, wiec UI musi je mapowac z powrotem
// na element_id i filtrowac przez isVisible.
let hrefToElementId: Map<string, string> | null = null;
function hrefElementIdMap(): Map<string, string> {
	if (hrefToElementId === null) {
		hrefToElementId = new Map();
		for (const mod of sidebarModules) {
			for (const item of getModuleItems(mod)) {
				hrefToElementId.set(item.href, sidebarItemElementId(mod.id, item));
			}
		}
	}
	return hrefToElementId;
}

/**
 * Maps an app href to the sidebar element_id that gates it. Exact match first,
 * then the longest sidebar item href that is a path-prefix (detail pages like
 * `/kontrakty/doplaty-gap/123` resolve to `sidebar.kontrakty.doplaty-gap`).
 * Returns null for hrefs outside sidebar-config (e.g. /moj-profil) — callers
 * should treat null as "not gated here" and rely on the route guard.
 */
export function getElementIdForHref(href: string): string | null {
	const map = hrefElementIdMap();
	const exact = map.get(href);
	if (exact) return exact;
	let bestHref: string | null = null;
	for (const itemHref of map.keys()) {
		if (
			href.startsWith(`${itemHref}/`) &&
			(bestHref === null || itemHref.length > bestHref.length)
		) {
			bestHref = itemHref;
		}
	}
	return bestHref ? (map.get(bestHref) ?? null) : null;
}

export interface ModuleIndexData {
	title: string;
	icon: LucideIcon;
	items: SidebarItem[];
	groups?: SidebarGroup[];
}

export function getModuleIndexData(basePath: string): ModuleIndexData | null {
	const flatItems: SidebarItem[] = [];
	const groupedSections: SidebarGroup[] = [];
	let title = "";
	let icon: LucideIcon = LayoutDashboard;

	const itemMatches = (item: SidebarItem) =>
		item.href === basePath || item.href.startsWith(`${basePath}/`);

	for (const mod of sidebarModules) {
		if (mod.isFavorites) continue;

		if (mod.items) {
			const matching = mod.items.filter(itemMatches);
			if (matching.length > 0) {
				flatItems.push(...matching);
				if (!title) {
					title = mod.title;
					icon = mod.icon;
				}
			}
		}

		if (mod.groups) {
			for (const group of mod.groups) {
				const matching = group.items.filter(itemMatches);
				if (matching.length > 0) {
					groupedSections.push({ ...group, items: matching });
					if (!title) {
						title = mod.title;
						icon = mod.icon;
					}
				}
			}
		}
	}

	if (flatItems.length === 0 && groupedSections.length === 0) return null;

	return {
		title,
		icon,
		items: flatItems,
		groups: groupedSections.length > 0 ? groupedSections : undefined,
	};
}

export function isModuleActive(
	module: SidebarModule,
	pathname: string,
	favorites: { href: string }[] = [],
): boolean {
	if (module.isFavorites) {
		return favorites.some((f) => pathname.startsWith(f.href));
	}
	if (module.items) {
		return module.items.some((item) => pathname.startsWith(item.href));
	}
	if (module.groups) {
		return module.groups.some((g) => g.items.some((item) => pathname.startsWith(item.href)));
	}
	return false;
}
